import domReady from './../utils/dom-ready.js';

let iframe;

function nop() {}

let logoutCallback = nop;
let statusCallback = nop;
const refreshCallback = nop;

function isNumeric(n) {
	return !isNaN(parseFloat(n)) && isFinite(n);
}

function changeIframeHeight(data) {
	if (data.newHeight !== undefined && isNumeric(data.newHeight)) {
		iframe.parentNode.style.height = `${data.newHeight}px`;
	}
}

function setBetslipItemsCount(data) {
	if (data.newItemsCount !== undefined && isNumeric(data.newItemsCount)) {
		const betslipCounter = document.getElementById('footerlink_bs_count');
		betslipCounter.textContent = data.newItemsCount;
		const bottomWrapper = document.querySelector('.js-bottom-wrapper');
		bottomWrapper.classList.remove('bottom-wrapper--is-hidden');
		const event = new CustomEvent('betsCounterChange');
		betslipCounter.dispatchEvent(event);
	}
}

function setOpenBetsItemCount(data) {
	if (data.openBetsCount !== undefined && isNumeric(data.openBetsCount)) {
		const openBetsCounter = document.getElementById('open_bets_counter');
		openBetsCounter.textContent = data.openBetsCount;
	}
}

function logoutFromIframeHandler() {
	logoutCallback();
}

function statusHandler() {
	statusCallback();
}

function refreshSessionHandler() {
	refreshCallback();
}

const eventHandlers = {
	CHANGE_IFRAME_SIZE_EVENT: changeIframeHeight,
	SET_BETSLIP_ITEMS_EVENT: setBetslipItemsCount,
	SET_OPENBETS_ITEMS_EVENT: setOpenBetsItemCount,
	LOGOUT_FROM_IFRAME_EVENT: logoutFromIframeHandler,
	STATUS_EVENT: statusHandler,
	REFRESH_EVENT: refreshSessionHandler
};

function receiveMessage(event) {
	const data = JSON.parse(event.data);
	console.info(`Parent got message: ${data.eventType}`, data.eventData);
	if (eventHandlers[data.eventType]) {
		eventHandlers[data.eventType](data.eventData);
	}
}

function status(data) {
	iframe.contentWindow.postMessage(JSON.stringify({
		eventType: 'STATUS_EVENT',
		eventData: {
			status: data
		}
	}), '*');
}

function registerLogoutCallback(logoutFn) {
	logoutCallback = logoutFn;
}

function registerStatusCallback(statusFn) {
	statusCallback = statusFn;
}

function login(token) {
	iframe.contentWindow.postMessage(JSON.stringify({
		eventType: 'LOGIN_EVENT',
		eventData: {
			token
		}
	}), '*'); // TODO restrict domains here?
}

function logout() {
	iframe.contentWindow.postMessage(JSON.stringify({
		eventType: 'LOGOUT_EVENT'
	}), '*');
}

function refreshIframe(newHash) {
	const iframeSrc = iframe.src;
	const iframeParent = iframe.parentNode;
	const iframeHeight = iframe.style.height;
	const newIframe = document.createElement('iframe');
	let newUrl = iframeSrc;

	if (newUrl.indexOf('#') >= 0) {
		newUrl = newUrl.substring(0, newUrl.indexOf('#'));
	}
	if (newHash) {
		newUrl = `${newUrl}#${newHash}`;
	}
	iframeParent.removeChild(iframe);
	newIframe.setAttribute('id', 'sbtech-iframe');
	newIframe.setAttribute('frameborder', '0');
	newIframe.setAttribute('framespacing', '0');
	newIframe.style.height = iframeHeight;
	newIframe.src = newUrl;
	iframeParent.appendChild(newIframe);
	iframe = newIframe;
}

function gotoHome() {
	refreshIframe();
}

function gotoSearch() {
	refreshIframe('search');
}

function gotoBetslip() {
	iframe.contentWindow.postMessage(JSON.stringify({
		eventType: 'GOTO_BETSLIP_EVENT'
	}), '*');
}

function gotoSettings() {
	iframe.contentWindow.postMessage(JSON.stringify({
		eventType: 'GOTO_SETTINGS_EVENT'
	}), '*');
}

function gotoBettingsHistory() {
	iframe.contentWindow.postMessage(JSON.stringify({
		eventType: 'GOTO_BETTING_HISTORY_EVENT'
	}), '*');
}

function init() {
	domReady.then(() => {
		iframe = document.getElementById('sbtech-iframe');
		if (iframe) {
			window.addEventListener('message', receiveMessage, false);
		}
	});
}

export default {
	init,
	api: {
		client: {
			login,
			logout,
			gotoHome,
			gotoSearch,
			gotoBetslip,
			gotoSettings,
			gotoBettingsHistory,
			registerLogoutCallback,
			registerStatusCallback,
			status
		}
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/sportsbook/sbtech.api.client-1.0.js